"use client";

import { useEffect, useRef, useState } from "react";

interface useStickyProps {
  options: {
    offset?: number;
  };
}

const useSticky = <T extends HTMLElement>({ options }: useStickyProps) => {
  const [sticky, setSticky] = useState(false);
  const ref = useRef<T>(null);
  const { offset } = options;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const initialTop = el.getBoundingClientRect().top + window.scrollY;

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setSticky(window.scrollY > initialTop - (offset ?? 0));
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [offset]);

  return { ref, sticky };
};

export default useSticky;

// export function useScrollProgress() {
//   const [progress, setProgress] = useState(0);

//   useEffect(() => {
//     const onScroll = () => {
//       const y = window.scrollY;
//       const h = document.documentElement.scrollHeight - window.innerHeight;
//       setProgress(h > 0 ? Math.min(100, Math.round((y / h) * 100)) : 0);
//     };

//     onScroll();
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   return progress; // 0 - 100
// }
